import type { Prototype } from "../prototype-types";

export const sharonChanPrototypes: Prototype[] = [
  {
    id: "brands-on-faire",
    name: "See Your Brands on Faire",
    path: "/shc/brands-on-faire",
    description:
      "Explores entry points to surface which brands retailers already buy from are on Faire, tying together the R2B referral reward (up to $2K) with POS integration to automatically identify off-platform brands and make referrals seamless.",
    owner: "Sharon Chan",
    createdAt: "2026-03-26",
    lastUpdated: "2026-08-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/38ef57975a31980a60170fc6513855a5184e6f030527162f3b6d6e7fbf8a5fd0.png",
    creationTool: "cursor",
  },
  {
    id: "progressive-modals-insider",
    name: "Progressive Modals: Insider",
    path: "/shc/progressive-modals-insider",
    description:
      "Exploring progressive disclosure patterns for Insider program modals.",
    owner: "Sharon",
    createdAt: "2026-01-12",
    lastUpdated: "2026-01-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d2a2af2ec608d2d6e3b9ace3902f28798a1f83d7db122b3083ce397160646118.png",
    creationTool: "cursor",
  },
  {
    id: "shc-account-dropdown-simplification",
    name: "Test 1 - Account Dropdown Simplification",
    path: "/shc/account-dropdown-simplification",
    description: "",
    owner: "Sharon Chan",
    createdAt: "2026-08-26",
    lastUpdated: "2026-08-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/shc-account-dropdown-simplification.png",
    creationTool: "claude-code",
  },
];
